export default __webpack_public_path__ + "static/ratio-9fe20d06313d7ee76ee5024c5758984b.jpg";